import { render, staticRenderFns } from "./EduBack.vue?vue&type=template&id=320d175f"
import script from "./EduBack.vue?vue&type=script&lang=js"
export * from "./EduBack.vue?vue&type=script&lang=js"
import style0 from "./EduBack.vue?vue&type=style&index=0&id=320d175f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports